<template>
  <Modal
    v-model="_value"
    width="400"
    title="创建网外部标服务合拼订单"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">
    <Form ref="jt808ServCombineOrderForm" :model="jt808ServCombineOrder">
      <FormItem prop="serviceDatetime">
        <Col span="6">
          <label>入网车辆</label>
        </Col>
        <Col span="18">
          <Select
            placeholder="请选合拼车辆"
            v-model="targetVehicleInfoId"
            @on-select="onTargetVehicleInfoSelect"
            filterable
            remote
            :remote-method="searchVehicleInfo"
            :loading="searchVehicleInfoLoading"
            class="field" style="width: 70%;"
            clearable>
            <Option v-for="(option, index) in searchVehicleInfoList" :value="option.id" :key="option.id">{{option.registrationNum}}</Option>
          </Select>
          <br/>
          <label style="color: red;">{{tips}}</label>
        </Col>
      </FormItem>
      <FormItem prop="serviceDatetime">
        <Col span="6">
          <label>入网日期</label>
        </Col>
        <Col span="18">
          <DatePicker type="date" style="width: 100%;" v-model="jt808ServCombineOrder.goInDatetime"
                      placeholder="选择日期"></DatePicker>
        </Col>
      </FormItem>
      <FormItem prop="serviceDatetime">
        <Col span="6">
          <label>服务到期日期</label>
        </Col>
        <Col span="18">
          <DatePicker type="date" style="width: 100%;" v-model="jt808ServCombineOrder.serviceDatetime"
                      placeholder="选择日期"></DatePicker>
        </Col>
      </FormItem>
      <FormItem prop="totalAmount">
        <Col span="6">
          <label>总金额</label>
        </Col>
        <Col span="18">
          <InputNumber :min="0" style="width: 100%;" v-model="jt808ServCombineOrder.totalAmount"
                       placeholder="请输入总金额">
          </InputNumber>
        </Col>
      </FormItem>
      <FormItem prop="billType">
        <Col span="6">
          <label>开票类型</label>
        </Col>
        <Col span="18">
          <Select style="width: 100%;" v-model="jt808ServCombineOrder.billType">
            <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Col>
      </FormItem>
      <FormItem prop="remark">
        <Col span="6">
          <label>备注</label>
        </Col>
        <Col span="18">
          <Input style="width: 100%;" v-model="jt808ServCombineOrder.remark"
                 type="textarea"
                 placeholder="请输入备注"></Input>
        </Col>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addjt808servcombineordermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchVehicleInfoList: [],
      searchVehicleInfoLoading: false,
      canAdd: false,
      tips: null,
      jt808ServCombineOrder: {
        deviceSource: 2,
        goInDatetime: null,
        renewalOrderId: null,
        serviceDatetime: null,
        targetPositioningDeviceInfoId: null,
        billType: 1,
        totalAmount: 0,
        remark: null
      },
      targetVehicleInfoId: null,
      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'Jt808ServCombineOrderServ_AddObj'
    ]),
    onTargetVehicleInfoSelect (val) {
      this.canAdd = false
      console.log(val)
      store.dispatch('Jt808ServCombineOrderServ_CheckVehicleInfo', {
        params: { vehicleInfoId: val.value },
        urlparams: null
      }).then(() => {
        let d = store.getters.get_Jt808ServCombineOrder_CheckVehicleInfoResult
        console.log(d)
        this.searchVehicleInfoLoading = false
        if (d.result) {
          this.canAdd = true
          this.jt808ServCombineOrder.targetPositioningDeviceInfoId = d.targetPositioningDeviceInfoId
        } else {
          this.canAdd = false
          this.tips = '车辆不符合合拼条件'
          this.$Message.error('车辆不符合合拼条件')
        }
      }).catch(err => {
        this.searchVehicleInfoLoading = false
        this.canAdd = false
      })
    },
    searchVehicleInfo (input) {
      this.searchVehicleInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoList = []
        this.searchVehicleInfoLoading = false
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoList = store.getters.get_VehicleInfo_SearchByNameResult ? store.getters.get_VehicleInfo_SearchByNameResult : []
          this.searchVehicleInfoLoading = false
        }).catch(err => {
          this.searchVehicleInfoLoading = false
        })
      }
    },
    onOk () {
      if (!this.canAdd) {
        this.$Message.error('车辆不符合合拼条件')
        return
      }

      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认服务期</p>',
        onOk: () => {
          store.dispatch('Jt808ServCombineOrderServ_AddObj',
            { params: this.jt808ServCombineOrder }).then(() => {
            this.$Message.success('添加成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.canAdd = false
        this.tips = null
        this.jt808ServCombineOrder.goInDatetime = new Date()
        this.jt808ServCombineOrder.serviceDatetime = null
        this.jt808ServCombineOrder.billType = 1
        this.jt808ServCombineOrder.receptDatetime = null
        this.jt808ServCombineOrder.totalAmount = 0
        this.jt808ServCombineOrder.remark = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
